var adjacent = require('./helper/adjacent');

module.exports = function succ(str) {
  return adjacent(str, 1);
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/succ.js
// module id = 1648
// module chunks = 0